<template>
  <div class="study_profile_modal__wrapper">
    <div class="study_profile_modal__container custom-width">

      <!-- HEADER -->
      <div class="modal__title d-flex justify-content-between py-2   px-3">
       <h4 class="mb-0">{{ $t("navigations.re-Consent campaign configuration") }}</h4>

        <div class="tooltip-wrapper pointer">
          <i class="fa fa-times" @click.prevent="closeModal"></i>
          <span class="custom-tooltip">{{ $t("navigations.close") }}</span>
        </div>
      </div>

      <div class="ibox-content p-3">

        <!-- SUBJECT BASIC DETAILS -->

        <div class="section-header d-flex justify-content-between align-items-center">

          <h5 class="my-0">Campaign Details</h5>

        </div>

        <div v-show="sectionState.basic">
          <div class="form-group row">
            <input type="hidden" v-model="values.patientId" />

          <div class="form-group row my-0 pr-0">

  <!-- Campaign Name -->
  <div class="col-lg-4">

    <label class="form-label-custom">
      {{ $t("navigations.campaign name") }}
      <sup><i class="fa fa-asterisk required"></i></sup>
    </label>

    <input
      type="text"
      class="form-control modern-input"
      v-model="values.campaignName"
      maxlength="1000"
    />
    <small v-if="errors.campaignName" class="text-danger">
  {{ errors.campaignName }}
</small>

  </div>

  <!-- Version -->
  <div class="col-lg-2">

    <label class="form-label-custom">
      {{ $t("navigations.version") }}
      <sup><i class="fa fa-asterisk required"></i></sup>
    </label>

    <input
      type="text"
      class="form-control modern-input"
      v-model="values.version"
      maxlength="1000"
      disabled
    />

  </div>

  <!-- Effective Date -->
  <div class="col-lg-3">

    <label class="form-label-custom">
      {{ $t("navigations.effective date") }}
    </label>

    <input
      type="date"
      class="form-control modern-input"
      v-model="values.enrollmentDate"
    />

  </div>

  <!-- Status -->
  <div class="col-lg-3 pr-0">

    <label class="form-label-custom">
      Status
    </label>

     <select
    class="form-select modern-input"
    v-model="values.status"
  >
    <option value="" disabled>Select</option>
    <option value="Active">Active</option>
    <option value="Inactive">Inactive</option>
  </select>

  </div>

</div>
          </div>
        </div>

        <!-- Applicability SECTION -->

        <!-- Applicability SECTION -->
<!-- Applicability SECTION -->
<div
  class="section-header d-flex justify-content-between align-items-center mt-3"
>
  <h5 class="my-0">Applicability</h5>

  <label class="custom-checkbox mb-0 applicability-all">
   <input
  type="checkbox"
  v-model="selectAllApplicability"
  @change="toggleAllApplicability"
/>
    <span>Select All</span>
  </label>
</div>
<div class="info-box mt-2 mb-3">
  When multiple filters are used, only subjects matching all selected criteria will be targeted. 
  Leaving a filter empty includes all values for that dimension.
</div>

<div v-show="sectionState.consent">

  <div class="form-group row mt-3">

    <!-- Countries -->
    <div class="col-lg-3 mb-0">

      <div class="d-flex justify-content-between align-items-center">

        <label class="col-form-label mb-0">
          {{ $t("navigations.country") }}
        </label>

        <label class="mini-checkbox">
          <input
            type="checkbox"
            v-model="selectAllCountries"
            @change="toggleAllCountries"
          />
          <span>Select All</span>
        </label>

      </div>

      <Multiselect
        v-model="values.countries"
        mode="multiple"
        valueProp="name"
        label="name"
        :placeholder="$t('navigations.select country')"
        :options="filteredCountries"
        :hideSelected="false"
        :closeOnSelect="false"
        class="multiselect-theme modern-multiselect"
      />

    </div>

    <!-- Sites -->
    <div class="col-lg-3 mb-0">

      <div class="d-flex justify-content-between align-items-center">

        <label class="col-form-label mb-0">
          {{ $t("navigations.site code") }}
        </label>

        <label class="mini-checkbox">
          <input
            type="checkbox"
            v-model="selectAllSites"
            @change="toggleAllSites"
          />
          <span>Select All</span>
        </label>

      </div>

      <Multiselect
        v-model="values.siteIds"
        mode="multiple"
        valueProp="siteID"
        label="siteCode"
        :placeholder="$t('navigations.select site code')"
        :options="sites"
        :hideSelected="false"
        :closeOnSelect="false"
        class="multiselect-theme modern-multiselect"
      />

    </div>

    <!-- Arm -->
    <div class="col-lg-3 mb-0">

      <div class="d-flex justify-content-between align-items-center">

        <label class="col-form-label mb-0">
          Arm Code
        </label>

        <label class="mini-checkbox">
          <input
            type="checkbox"
            v-model="selectAllArmCodes"
            @change="toggleAllArmCodes"
          />
          <span>Select All</span>
        </label>

      </div>

      <Multiselect
        v-model="values.armCodes"
        mode="multiple"
        valueProp="ArmCode"
        label="ArmCode"
        :placeholder="$t('navigations.select arm code')"
        :options="armList"
        :hideSelected="false"
        :closeOnSelect="false"
        class="multiselect-theme modern-multiselect"
      />

    </div>

    <!-- Cohort -->
    <div class="col-lg-3 mb-0">

      <div class="d-flex justify-content-between align-items-center">

        <label class="col-form-label mb-0">
          Cohort
        </label>

        <label class="mini-checkbox">
          <input
            type="checkbox"
            v-model="selectAllCohorts"
            @change="toggleAllCohorts"
          />
          <span>Select All</span>
        </label>

      </div>

      <Multiselect
        v-model="values.cohorts"
        mode="multiple"
        valueProp="id"
        label="cohortName"
        :placeholder="$t('navigations.select cohort')"
        :options="cohortList"
        :hideSelected="false"
        :closeOnSelect="false"
        class="multiselect-theme modern-multiselect"
      >

        <template #option="{ option }">
          {{ option.cohortName }} ({{ option.cohortCode }})
        </template>

        <template #tag="{ option, handleTagRemove, disabled }">
          <div class="multiselect-tag">
            {{ option.cohortName }} ({{ option.cohortCode }})
            <span
              v-if="!disabled"
              class="multiselect-tag-remove"
              @click="handleTagRemove(option, $event)"
            >
              ×
            </span>
          </div>
        </template>

      </Multiselect>

    </div>

  </div>
  

</div>

        <!-- Subject Selection Rules -->
     <!-- Subject Selection Rules -->
<div class="section-header d-flex justify-content-between align-items-center mt-3">
  <h5 class="my-0">Subject Selection Rules</h5>

  <label class="custom-checkbox mb-0 applicability-all">
    <input
      type="checkbox"
      v-model="selectAllSubjectStatuses"
      @change="toggleAllSubjectStatuses"
    />
    <span>Select All</span>
  </label>
</div>
<div class="info-box mt-2 mb-3">
 Select subject statuses to target for this campaign. 
 If none are selected, all subject statuses will be included automatically.
</div>

<div class="form-group row mt-3">

  <div class="col-lg-12">

 <div class="checkbox-grid">

  <label
    class="custom-checkbox"
    v-for="status in subjectStatusList"
    :key="status.statusId"
  >
    <input
      type="checkbox"
      :value="status.status"
      v-model="values.subjectStatuses"
    />

    <span>
      {{ status.status }}
    </span>

  </label>

</div>

  </div>

</div>

        <!-- ENROLLMENT-->
  <!-- Workflow Rules -->
<div class="section-header d-flex justify-content-between align-items-center mt-3">
  <h5 class="my-0">Workflow Rules</h5>
</div>

<div class="form-group row mt-3">

  <!-- Checkbox Cards -->
  <div class="col-lg-12">

    <div class="checkbox-grid">

      <label class="custom-checkbox">
        <input type="checkbox" v-model="values.lockVisits" />
        <span>Lock Future Visits</span>
      </label>

      <label class="custom-checkbox">
        <input type="checkbox" v-model="values.requireSignature" />
        <span>Require Investigator Signature</span>
      </label>

      <label class="custom-checkbox">
        <input type="checkbox" v-model="values.allowRemoteConsent" />
        <span>Allow Remote Consent</span>
      </label>

      <label class="custom-checkbox">
        <input type="checkbox" v-model="values.freezeList" />
        <span>Freeze Affected Subject List</span>
      </label>

    </div>

  </div>

  <!-- Dropdowns -->
<div class="col-lg-6 mb-3">
  <label class="form-label-custom">
    Allowed Forms During Visit Lock
  </label>
  <Multiselect
    v-model="values.allowedFormsDuringLock"
    mode="multiple"
    valueProp="templateName"
    label="templateName"
    :placeholder="'Select forms'"
    :options="allowedFormsList"
    :hideSelected="false"
    :closeOnSelect="false"
    :maxHeight="150"
    class="multiselect-theme modern-multiselect"
  />
</div>

<div class="col-lg-6 mb-3">

  <label class="form-label-custom">
    Visit Lock Mode
  </label>

  <select
    class="form-select modern-input"
    v-model="values.lockMode"
  >
    <option value="" disabled>Select</option>
    <option value="Visit Level">Visit Level</option>
    <option value="Form Level">Form Level</option>
  </select>

</div>

</div>
<!-- Notification -->
<div class="section-header d-flex justify-content-between align-items-center mt-3">
  <h5 class="my-0">Notification</h5>
</div>

<div class="form-group row mt-3">
  <div class="col-lg-6 col-md-12 mb-3">
    <label class="form-label-custom">
      {{ $t("navigations.select roles to Notify") }}
    </label>
<Multiselect
  v-model="selectedRoles"
  mode="multiple"
  valueProp="roleID"      
  label="roleName"
  placeholder="Select roles"
  :options="roleList"
  :hideSelected="false"
  :closeOnSelect="false"
  class="multiselect-theme modern-multiselect"
/>
  </div>
</div>
<!-- <div class="section-header d-flex justify-content-between align-items-center mt-3">
  <h5 class="my-0">Preview</h5>
</div> -->
        <div class="col-lg-12 mt-4">

          <div class="d-flex justify-content-end">

            <button class="cancel_btn py-1 px-4 mx-3" @click="clearForm()">

              {{ $t("navigations.clear") }}

            </button>
            <!-- <button class="save_btn py-1 px-4" @click="saveOrEditPatient()">

              {{ $t("navigations.save") }}

            </button> -->
            <button
  class="save_btn py-1 px-4"
  :disabled="isSaving"
  @click="saveReconsentCampaign()"
>
  <span
    v-if="isSaving"
    class="spinner-border spinner-border-sm me-2"
    role="status"
    aria-hidden="true"
  ></span>
  {{ $t("navigations.activate campaign") }}
</button>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script src="./ReconsentCampaignmodal.js"></script>

<style scoped>
.study_profile_modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
}

.study_profile_modal__container {
  border-radius: 4px;
  background: #fff;
  width: min(1000px, 90%);
  max-height: 90vh;

  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* important */
}

/* HEADER stays fixed */
.modal__title {
  background-color: var(--pop-up-background);
  color: white;
  flex-shrink: 0;
  /* prevents shrinking */
  position: sticky;
  top: 0;
  z-index: 10;
}

/* SCROLL ONLY THIS */
.ibox-content {
  overflow-y: auto;
  flex-grow: 1;
}

.cancel_btn {
  padding: 0.43rem 0.4rem;
  border-radius: 0.25rem;
}

.custom-width {
  width: min(1000px, 90%);
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.custom-tooltip {
  visibility: hidden;
  width: 60px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: -25%;
  /* Position the tooltip above the icon */
  left: -375%;
  margin-left: -30px;
  /* Use half of the width to center-align */
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 12px;
}

.tooltip-wrapper:hover .custom-tooltip {
  visibility: visible;
  opacity: 1;
}

.section-header {
  cursor: pointer;
  padding: 4px 8px;
  background-color: #dbe7e7;
  border: 0px;
  border-radius: 5px;
}

.section-header h5 {
  font-size: 13px;
  font-weight: 600;
}

.phase-selector {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* CHIP */
.phase-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1.5px solid #d1dde8;
  border-radius: 6px;
  padding: 1px 5px;
  cursor: pointer;
  background: #f8fafc;
  font-size: 13px;
  font-weight: 500;
  color: #4a6080;
  transition: all 0.2s ease;
  user-select: none;
}

/* Hide default checkbox */
.phase-chip input {
  width: 16px;
  height: 16px;
  accent-color: #2563eb;
  cursor: pointer;
}

/* Hover */
.phase-chip:hover {
  border-color: #2563eb;
  background: #dbeafe;
  color: #1d4ed8;
}

/* Active (selected) */
.phase-chip.activephase {
  border-color: #2563eb;
  background: #dbeafe;
  color: #1d4ed8;
}
.subreg h5{
  font-size: 16px;
  font-weight: 500;
}
.multi-select-dropdown {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 10px;
  background: #fff;
}

.dropdown-list {
  max-height: 250px;
  overflow-y: auto;
}

.form-check {
  display: flex;
  align-items: center;
  gap: 8px;
}
.multiselect-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}
.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 8px 20px;
  margin-top: 6px;
}

.custom-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 8px;
  border: 1px solid #d9e2ec;
  border-radius: 4px;
  background: #f8fafc;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 12px;
  font-weight: 500;
}

.custom-checkbox:hover {
  border-color: #4f46e5;
  background: #eef2ff;
}

.custom-checkbox input[type="checkbox"] {
  width: 12px;
  height: 12px;
  cursor: pointer;
}

.custom-checkbox span {
  line-height: 1.2;
}



/* Better label spacing */
.col-form-label,
.form-check-label,
label {
  font-weight: 500;
  margin-bottom: 6px;
}

/* Better section spacing */
.form-group.row {
  margin-top: 12px;
}


.modern-select:focus {
  border-color: #4f46e5;
  box-shadow: 0 0 0 0.1rem rgba(79, 70, 229, 0.15);
}

.modern-multiselect {
  min-height: 42px;
}

.applicability-all {
  padding: 1px 10px;
}

.mini-checkbox {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 500;
  color: #4b5563;
  margin-bottom: 0;
  cursor: pointer;
}

.mini-checkbox input[type="checkbox"] {
  width: 14px;
  height: 14px;
  cursor: pointer;
}

.col-form-label {
  font-weight: 600;
  color: #374151;
}

.multiselect-theme {
  width: 100%;
}
.multiselect{
  font-size: var(--ms-font-size, .75rem) !important;
    min-height: calc(var(--ms-border-width, 1px) * 2 + var(--ms-font-size, .75rem) * var(--ms-line-height, 1) + var(--ms-py, .5rem) * 1.5) !important;
}
.study_profile_modal__wrapper .ibox-content {
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 8px;
}
.info-box {
  padding: 10px 14px;
  border: 1px solid #cfe2ff;
  background: #f4f8ff;
  border-radius: 6px;
  color: #4a6fa5;
  font-size: 12px;
  line-height: 1.6;
}

</style>